"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureDefinitions = exports.featureValue = exports.validDateString = exports.environment = exports.context = exports.entity = exports.boolean = exports.number = exports.string = exports.object = exports.isValid = void 0;
const types_1 = require("./types");
const z = __importStar(require("myzod"));
function isValid(input) {
    return !(input instanceof z.ValidationError);
}
exports.isValid = isValid;
const toString = (obj) => Object.prototype.toString.call(obj);
const object = (obj) => toString(obj) === '[object Object]';
exports.object = object;
const string = (obj) => typeof obj === 'string';
exports.string = string;
const number = (obj) => typeof obj === 'number';
exports.number = number;
const boolean = (obj) => typeof obj === 'boolean';
exports.boolean = boolean;
const entity = (obj) => isValid(types_1.EntityChecker.try(obj));
exports.entity = entity;
const context = (obj) => 
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument
(0, exports.object)(obj) && Object.keys(obj).every((key) => (0, exports.entity)(key) && (0, exports.string)(obj[key]));
exports.context = context;
const environment = (obj) => isValid(types_1.EnvironmentChecker.try(obj));
exports.environment = environment;
const validDateString = (obj) => !isNaN(new Date(obj).getTime());
exports.validDateString = validDateString;
const featureValue = (obj) => isValid(types_1.FeatureValue.try(obj));
exports.featureValue = featureValue;
const featureDefinitions = (obj) => isValid(types_1.FeatureDefinitions.try(obj));
exports.featureDefinitions = featureDefinitions;
//# sourceMappingURL=is.js.map